// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".machine-name[data-v-1ae68b68] {\n  font-family: \"Roboto-Medium\", sans-serif;\n  text-transform: uppercase;\n  font-size: 18px;\n  line-height: 20px;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
